import KeyframeLogoFullSvg from "components/icons/keyframe-logo-full.svg";
import ParticleCircle from "components/animations/ParticleCircle";

export default function ErrorLayout(p: React.PropsWithChildren) {
  return (
    <div className="h-screen bg-neutral-100 p-8 md:p-12">
      <KeyframeLogoFullSvg className="absolute left-8 top-8 h-7" />

      <div className="flex h-full items-center gap-10">
        <div className="flex-1 px-4 py-8">
          <div className="mx-auto space-y-6 md:max-w-lg lg:space-y-12">
            {p.children}
          </div>
        </div>
        <div
          className="hidden flex-1 shrink-0 self-stretch 
          rounded-3xl bg-red-400 bg-opacity-10 xl:flex"
        >
          <ParticleCircle variant="red" />
        </div>
      </div>
    </div>
  );
}
